// src/pages/Ejemplo.jsx
import React, { useState } from 'react';
import { NavbarEmpresaPrueba } from '../components/MaterialUi/nav_empresa';
import {
  PDFViewer,
  Document,
  Page,
  Text,
  StyleSheet,
} from '@react-pdf/renderer';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

/* ---------- estilos que usará react-pdf ---------- */
const pdfStyles = StyleSheet.create({
  page: { padding: 40, fontFamily: 'Helvetica' },
  title: { fontSize: 24, marginBottom: 20 },
  body: { fontSize: 12, lineHeight: 1.4 },
});

/* ---------- documento PDF (recibe props) ---------- */
const MyDoc = ({ title, body }) => (
  <Document>
    <Page size="A4" style={pdfStyles.page}>
      <Text style={pdfStyles.title}>{title}</Text>
      <Text style={pdfStyles.body}>{body}</Text>
    </Page>
  </Document>
);

export const Ejemplo = () => {
  /* -------- estados editables -------- */
  const [title, setTitle] = useState('Título editable');
  const [body, setBody] = useState(
    'Haz clic en el texto y edítalo.\nEl diálogo usa Material UI.'
  );

  /* -------- diálogo Material UI -------- */
  const [open, setOpen] = useState(false);
  const [field, setField] = useState('title'); // 'title' | 'body'
  const [temp, setTemp] = useState('');

  const handleOpen = (key) => {
    setField(key);
    setTemp(key === 'title' ? title : body);
    setOpen(true);
  };

  const handleSave = () => {
    field === 'title' ? setTitle(temp) : setBody(temp);
    setOpen(false);
  };

  return (
    <>
      <NavbarEmpresaPrueba />

      {/* -------- zona de trabajo -------- */}
      <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex' }}>
        <Box sx={{ flex: 1, position: 'relative' }}>
          {/* Vista previa del PDF */}
          <PDFViewer width="100%" height="100%">
            <MyDoc title={title} body={body} />
          </PDFViewer>

          {/* Overlays transparentes que capturan el clic */}
          <Box
            sx={{
              position: 'absolute',
              top: 60,
              left: 60,
              width: 300,
              height: 40,
              cursor: 'pointer',
            }}
            onClick={() => handleOpen('title')}
          />
          <Box
            sx={{
              position: 'absolute',
              top: 120,
              left: 60,
              width: 400,
              height: 460,
              cursor: 'pointer',
            }}
            onClick={() => handleOpen('body')}
          />
        </Box>
      </Box>

      {/* Diálogo de edición */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Editar {field === 'title' ? 'título' : 'cuerpo'}</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            minRows={field === 'title' ? 1 : 6}
            fullWidth
            variant="outlined"
            value={temp}
            onChange={(e) => setTemp(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button variant="contained" onClick={handleSave}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
